import React from 'react';
import { Link } from "react-router-dom";

const Reparchaseclick = () => {
  return (
    <div>
        
        <section>
      <div className="container-fluid">
        <div className="row">
        

          <div className="col-lg-10 mt-3 mb-3">
            <div className="row">
              <div className="col-lg-1 text-end">
                <Link to="/">
                  <h6>
                    <i class="fa fa-home" aria-hidden="true"></i>Home
                  </h6>
                </Link>
              </div>
              /
              <div className="col-lg-5">
                <h6>Reparchase Admin Charges Details</h6>
              </div>
            </div>

            <div className="row">
              <div className="card border-0 shadow ">
                <div className="card-header bg bg-info border-0">
                  <h4> Reparchase Charges Details</h4>
                </div>

                <div className="card-body">
                  {/* ==============================Search start================ */}

                  <div className="col-lg-12 ">
                    <div className="row text-end">
                      <div className="col-lg-6"></div>
                      <div className="col-lg-3">
                        <label for="exampleInputPassword1" class="form-label">
                          Search:
                        </label>
                      </div>

                      <div className="col-lg-3">
                        <input
                          type="password"
                          class="form-control"
                          placeholder="Sponsor ID"
                          id="exampleInputPassword1"
                        />
                      </div>
                    </div>
                  </div>

                  {/* ==============================Search end================ */}

                  {/* ==============================table start========================= */}

                  <div className="col-lg-12 mt-3">
                    <div class="table-responsive">
                      <table class="table table-bordered  mb-0 text-nowrap">
                        <thead>
                          <tr>
                            <th> Sl.No </th>
                            <th>User ID</th>
                            <th>Withdraw Amount</th>
                            <th>Charges </th>
                            <th>Admin Amount</th>
                            <th>Status</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>01</td>
                            <td>UI123</td>
                            <td>Rs 5000</td>
                            <td>3000</td>
                            <td>3000</td>
                            <td>
                              <button
                                type="button"
                                class="btn btn-sm btn-warning"
                                data-toggle="modal"
                                data-target="#exampleModal"
                              >
                                Process
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* ==============================table end========================= */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
  )
}

export default Reparchaseclick;